const NONE_SENTINEL = "-";

/** Normalize raw kashrutFeature (string | {id,name}) to a display name, or "" for none/"-". */
export const getKashrutFeatureName = (rawFeature) => {
  let name = "";
  if (rawFeature && typeof rawFeature === "object") {
    name = rawFeature.name || "";
  } else if (typeof rawFeature === "string") {
    name = rawFeature;
  }
  return name && name !== NONE_SENTINEL ? name : "";
};

/** Product-level accessor — encodes the "-" admin "none" sentinel once. */
export const getKashrutFeature = (product) =>
  getKashrutFeatureName(product?.kosherSupervision?.[0]?.kashrutFeature);

export const isShowableClassification = (kashrut) =>
  kashrut === "בשרי" || kashrut === "חלבי" || kashrut === "פרווה";

export const getClassificationClassName = (kashrut) => {
  if (kashrut === "בשרי") return "fleshy";
  if (kashrut === "חלבי") return "milky";
  if (kashrut === "פרווה") return "parve";
  return "";
};

/** Customer-facing brand label: sub-brand (מותג), then brand (ספק). */
export const getProductBrandLabel = (product) => {
  if (!product) return "";
  const subBrand = product.subBrand ?? product.sub_brand;
  const brand = product.brand;
  return subBrand?.name || brand?.name || "";
};

export const shouldShowProductBrand = (
  product,
  { alwaysShow = false } = {},
) => {
  if (!getProductBrandLabel(product)) return false;
  if (alwaysShow) return true;
  return Boolean(product.viewBrand ?? product.view_brand);
};

/** Plain-text meta parts for compact cart rows (joined with ·). */
export const getProductMetaTextParts = (
  product,
  { showKashrutFeature = false, alwaysShowBrand = false } = {},
) => {
  if (!product) return [];

  const parts = [];
  if (shouldShowProductBrand(product, { alwaysShow: alwaysShowBrand })) {
    parts.push(getProductBrandLabel(product));
  }
  if (product.logisticsDetails?.packageQuantity > 1) {
    parts.push(`${product.logisticsDetails.packageQuantity} ×`);
  }
  if (product.weightDetails) {
    const weight = [
      product.weightDetails.netContent,
      product.weightDetails.unitOfMeasure,
    ]
      .filter(Boolean)
      .join(" ");
    if (weight) parts.push(weight);
  }

  const kashrut = product.kosherSupervision?.[0]?.classification ?? "";
  if (isShowableClassification(kashrut)) parts.push(kashrut);

  if (showKashrutFeature) {
    const featureName = getKashrutFeature(product);
    if (featureName) parts.push(featureName);
  }

  return parts;
};
